const ProgressBar = ({ width }) => {
  return <div className="fixed bottom-0 left-0 w-full h-4 bg-gray-200 z-100">
    <div className="h-full bg-[#1D8AF7] transition-all duration-300" style={{ width }}></div>
  </div>
}

export default ProgressBar
